import { observer } from "mobx-react-lite";
import React, { useEffect, useId, useState } from "react";
import ApiData from "../../api/ApiData";
import Msg from "../../api/Msg";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { SiteFormField } from "../UI/SiteFormField";
import User from "../../api/User";
import { License1cCalculator } from "./License1cCalculator";

const PERIOD_INFINITY = 36500;

export const GenerationLicense = observer(({ open, onClose, prefill }) => {
  const titleId = useId();
  const [count, setCount] = useState(1);
  const [period, setPeriod] = useState(PERIOD_INFINITY);
  const [description, setDescription] = useState("");
  const [liteVersion, setLiteVersion] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }
    const nextCount = Math.max(1, prefill?.count ?? 1);
    const nextLite = Boolean(prefill?.liteVersion);
    setCount(nextCount);
    setLiteVersion(nextLite);
    setPeriod(PERIOD_INFINITY);
    setDescription("");
  }, [open, prefill]);

  const handlerCount = (e) => {
    if (e.target.value < 0) {
      return setCount(0);
    }
    return setCount(e.target.value);
  };

  const applyInfinityPeriod = () => {
    setPeriod(PERIOD_INFINITY);
  };

  const close = () => onClose?.();

  const generationLicense = () => {
    if (description === "")
      return Msg.writeMessages("Поле комментария не заполнено");
    ApiData.generationLicense(
      count,
      period,
      liteVersion,
      `Лицензию добавил ${User.user.last_name} ${User.user.first_name} ${User.user.father_name}. ${description}`,
    );
    close();
    setDescription("");
  };

  if (!open) {
    return null;
  }

  return (
    <SideDrawer
      open={open}
      title="Генерация лицензий"
      titleId={titleId}
      onClose={close}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4
            onClick={generationLicense}
            text="Сгенерировать лицензии"
            footerSize
          />
          <BtnOutlineV4 onClick={close} text="Отмена" />
        </>
      }
    >
      <div className="site-modal-body">
            <div className="site-modal-fields subscription-modal-fields">
              <License1cCalculator active={open} />

              {/* <div className="site-form-field">
                <span className="site-form-label">Выберите срок лицензии</span>
                <div className="subscription-period-chips">
                  <button
                    type="button"
                    className="subscription-period-chip subscription-period-chip--active"
                    onClick={applyInfinityPeriod}
                  >
                    Бессрочно
                  </button>
                </div>
              </div> */}

              <SiteFormField label="Версия ПО" as="div">
                <div className="subscription-period-chips">
                  <button
                    type="button"
                    className={
                      liteVersion
                        ? "subscription-period-chip"
                        : "subscription-period-chip subscription-period-chip--active"
                    }
                    onClick={() => setLiteVersion(false)}
                  >
                    Pro
                  </button>
                  {/* <button
                    type="button"
                    className={
                      liteVersion
                        ? "subscription-period-chip subscription-period-chip--active"
                        : "subscription-period-chip"
                    }
                    onClick={() => setLiteVersion(true)}
                  >
                    Lite
                  </button> */}
                  <label className="flx-sb">
                    <span className="site-form-label">кол-во</span>
                    <input
                      className="license-count-input"
                      onChange={handlerCount}
                      value={count}
                      type="number"
                      placeholder="1"
                      min="1"
                    />
                  </label>
                </div>
              </SiteFormField>

              <SiteFormField label="Комментарий">
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="subscription-contract-text"
                  rows={4}
                />
              </SiteFormField>
            </div>
          </div>
    </SideDrawer>
  );
});
